import { getColor } from '../utils';

import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const InAppDelete = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 24 24" {...props}>
    <path
      d="M19.3201 9.18994V4.68994C19.3201 4.39157 19.2015 4.10542 18.9906 3.89445C18.7796 3.68347 18.4934 3.56494 18.1951 3.56494H4.69507C4.3967 3.56494 4.11055 3.68347 3.89957 3.89445C3.68859 4.10542 3.57007 4.39157 3.57007 4.68994V17.0649C3.57007 17.3633 3.68859 17.6495 3.89957 17.8604C4.11055 18.0714 4.3967 18.1899 4.69507 18.1899H9.19507"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.2993 19.4482H12.5493L11.9868 11.5732H19.8618L19.2993 19.4482Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.8618 11.5732H20.9868"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.7993 13.8232V17.1982"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.0493 13.8232V17.1982"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.57007 6.93994H19.3201"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
